import { Box, Typography, useTheme, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CreateActivityTemplateContainer from './CreateActivityTemplateContainer';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { setDraftActivity } from '../../redux/activity/activitySlice';
import StyledButton from '../Common/StyledButton';

interface ICreateNewActivityProps {
  closeModel: () => void;
  handleNext: () => void;
}

function CreateNewActivity({ closeModel, handleNext }: ICreateNewActivityProps) {
  const theme = useTheme();
  const dispatch = useAppDispatch();
  const selectedActivityTemplate = useAppSelector((state) => state.activity.selectedTemplate);
  const { t } = useTranslation();

  //  when user click activity ( in magic suggestion or template activity or blank activity)
  const templateSelectHandler = () => {
    if (!selectedActivityTemplate) {
      return;
    }
    dispatch(
      setDraftActivity({
        name: selectedActivityTemplate?.activity?.name,
        type: selectedActivityTemplate?.activity?.type,
        objective: selectedActivityTemplate?.activity?.objective,
        ActivityStep: selectedActivityTemplate?.activity?.ActivityStep,
        frequency: selectedActivityTemplate?.activity?.frequency,
        situation: selectedActivityTemplate?.activity?.situation,
        isAddToLibrary: selectedActivityTemplate.activity.isAddToLibrary,
      })
    );
    handleNext();
  };

  return (
    <Grid
      p={{ xs: '12px', sm: '16px', md: '24px', lg: '32px' }}
      width="100%"
      height="95vh"
      minWidth="70vw"
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      gap="16px"
    >
      {/* Header */}
      <Grid>
        <Grid display="flex" justifyContent="space-between" maxHeight="50px" flex="1">
          <Typography variant="h4" color="primary.main">
            {t('activity.createActivity.createNewActivity')}
          </Typography>
          <img
            src="/assets/icons/close-circle-large.svg"
            alt="close-icon"
            onClick={closeModel}
            role="presentation"
            style={{
              cursor: 'pointer',
            }}
          />
        </Grid>
      </Grid>

      <Box
        width="100%"
        border={theme.borderStyles.commonBorders}
        flex="2"
        maxHeight="65vh"
        overflow="hidden"
      >
        <CreateActivityTemplateContainer />
      </Box>

      <Box display="flex" alignItems="center" justifyContent="flex-end">
        <StyledButton onClick={templateSelectHandler}>
          {t('activity.createActivity.selectAndCustomize')}
        </StyledButton>
      </Box>
    </Grid>
  );
}

export default CreateNewActivity;
